"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeKevelBannersFromJlDataByAdIds = exports.addKevelBannersToJlData = exports.clearKevelBannersFromJlData = exports.addKevelBannerToJlData = exports.clearCitrusBannersFromJlData = exports.addCitrusBannerToJlData = void 0;
const addCitrusBannerToJlData = ({ adId, type, campaignName, }) => {
    if (window && adId && campaignName && type) {
        const ad = {
            adId,
            type,
            campaignName,
        };
        window.jlData = Object.assign(Object.assign({}, window.jlData), { citrusBannerAds: [ad] });
    }
};
exports.addCitrusBannerToJlData = addCitrusBannerToJlData;
const clearCitrusBannersFromJlData = () => {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.jlData) === null || _a === void 0 ? void 0 : _a.citrusBannerAds) {
        delete window.jlData.citrusBannerAds;
    }
};
exports.clearCitrusBannersFromJlData = clearCitrusBannersFromJlData;
/**
 * Deep clones a Kevel banner event to prevent shared reference issues.
 * This ensures that mutations to the original object don't affect stored data.
 */
const cloneKevelBannerData = (event) => ({
    adId: event.adId,
    type: event.type,
    clickUrl: event.clickUrl,
    impressionUrl: event.impressionUrl,
});
const addKevelBannerToJlData = ({ adId, type, clickUrl, impressionUrl, }) => {
    var _a;
    if (window && adId && type && clickUrl && impressionUrl) {
        const existingAds = ((_a = window.jlData) === null || _a === void 0 ? void 0 : _a.kevelBannerAds) || [];
        // Check if banner with this adId already exists (deduplication)
        const adExists = existingAds.some((ad) => ad.adId === adId);
        if (adExists) {
            // Update existing banner with new data
            const updatedAds = existingAds.map((ad) => ad.adId === adId
                ? cloneKevelBannerData({ adId, type, clickUrl, impressionUrl })
                : ad);
            window.jlData = Object.assign(Object.assign({}, window.jlData), { kevelBannerAds: updatedAds });
        }
        else {
            // Deep clone to prevent reference issues
            const clonedAd = cloneKevelBannerData({
                adId,
                type,
                clickUrl,
                impressionUrl,
            });
            window.jlData = Object.assign(Object.assign({}, window.jlData), { kevelBannerAds: [...existingAds, clonedAd] });
        }
    }
};
exports.addKevelBannerToJlData = addKevelBannerToJlData;
const clearKevelBannersFromJlData = () => {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.jlData) === null || _a === void 0 ? void 0 : _a.kevelBannerAds) {
        delete window.jlData.kevelBannerAds;
    }
};
exports.clearKevelBannersFromJlData = clearKevelBannersFromJlData;
const addKevelBannersToJlData = (events) => {
    var _a;
    if (!window || events.length === 0) {
        return;
    }
    const validEvents = events.filter(({ adId, type, clickUrl, impressionUrl }) => adId && type && clickUrl && impressionUrl);
    if (validEvents.length === 0) {
        return;
    }
    const existingAds = ((_a = window.jlData) === null || _a === void 0 ? void 0 : _a.kevelBannerAds) || [];
    const existingAdIds = new Set(existingAds.map((ad) => ad.adId));
    // Deep clone and deduplicate: only add banners with new adIds
    const clonedNewEvents = validEvents
        .map(cloneKevelBannerData)
        .filter((ad) => !existingAdIds.has(ad.adId));
    window.jlData = Object.assign(Object.assign({}, window.jlData), { kevelBannerAds: [...existingAds, ...clonedNewEvents] });
};
exports.addKevelBannersToJlData = addKevelBannersToJlData;
const removeKevelBannersFromJlDataByAdIds = (adIds) => {
    var _a;
    if (!window || adIds.length === 0 || !((_a = window.jlData) === null || _a === void 0 ? void 0 : _a.kevelBannerAds)) {
        return;
    }
    const adIdSet = new Set(adIds.filter(Boolean));
    if (adIdSet.size === 0) {
        return;
    }
    const filteredAds = window.jlData.kevelBannerAds.filter(({ adId }) => !adIdSet.has(adId));
    if (filteredAds.length > 0) {
        window.jlData = Object.assign(Object.assign({}, window.jlData), { kevelBannerAds: filteredAds });
        return;
    }
    delete window.jlData.kevelBannerAds;
};
exports.removeKevelBannersFromJlDataByAdIds = removeKevelBannersFromJlDataByAdIds;
